<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="940">
      <v-card>
        <v-card-title
          >พนักงานในบทบาท {{ employeeListInRole.title }}</v-card-title
        >
        <v-card-text>
          <div class="d-flex align-center mb-4">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              dense
              hide-details
              placeholder="รหัส - ชื่อพนักงาน"
            ></v-text-field>
            <v-btn
              color="primary"
              class="ml-2"
              @click="employeeListDialog = true"
            >
              <v-icon>mdi-plus</v-icon> เพิ่มพนักงาน
            </v-btn>
          </div>
          <v-data-table
            :loading="loading"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :search="search"
            :headers="headers"
            :items="employeeListInRole.employees"
            :items-per-page="5"
            class="elevation-1"
            :footer-props="{
              itemsPerPageText: 'Rows per page:',
              disableItemsPerPage: true,
            }"
            height="288"
          >
            <template v-slot:item.firstname_th="{ item }">
              {{ item.firstname_th }} {{ item.lastname_th }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small @click="deleteEmployeeListInRole(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-btn outlined @click="onClose" :disabled="loading"> ปิด </v-btn>
          <v-btn outlined @click="onRefresh" :disabled="loading">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <EmployeeListDialog
      :dialog="employeeListDialog"
      :singleSelect="false"
      @cancelEmployeeListDialog="cancelEmployeeListDialog"
      @submitEmployeeListDialog="submitEmployeeListDialog"
    />
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
  </v-row>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeListDialog from '@/components/EmployeeListDialog.vue'

export default {
  name: 'EmployeeListInRoleDialog',
  components: {
    ConfirmDialog,
    EmployeeListDialog,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      sortBy: ['employee_code'],
      sortDesc: [false],
      search: '',
      headers: [
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          width: 140,
          value: 'employee_code',
        },
        { text: 'ชื่อพนักงาน', value: 'firstname_th' },
        {
          text: 'หน่วยงาน',
          width: 180,
          value: 'organization.title_th',
        },
        {
          text: 'ตำแหน่ง',
          width: 180,
          value: 'position.title_th',
        },
        { text: 'Actions', value: 'actions', width: 80, sortable: false },
      ],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      employeeListDialog: false,
    }
  },
  computed: {
    employeeListInRole() {
      return this.$store.state.userRole.employeeListInRole
    },
  },
  methods: {
    ...mapActions({
      fetchEmployeeListInRole: 'userRole/fetchEmployeeListInRole',
      updateEmployeeListInRole: 'userRole/updateEmployeeListInRole',
    }),

    cancelEmployeeListDialog() {
      this.employeeListDialog = false
    },

    async submitEmployeeListDialog(selectedItems) {
      try {
        const employeeListInRole = this.$store.state.userRole.employeeListInRole
        const results = _.uniqBy(
          [...employeeListInRole.employees, ...selectedItems],
          'employee_uuid'
        ).map((item) => item.employee_uuid)

        this.employeeListDialog = false

        this.loading = true

        await this.updateEmployeeListInRole({
          company_uuid: this.$store.state.authentication.company.company_uuid,
          role_uuid: this.employeeListInRole.role_uuid,
          data: {
            employees: results,
          },
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'บันทึกข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },

    deleteEmployeeListInRole(item) {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: `คุณต้องการลบพนักงานในบทบาท`,
        value: `${item.employee_code} : ${item.firstname_th} ${item.lastname_th}`,
        item,
      }
    },

    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },

    async submitConfirmDialogDelete(item) {
      try {
        this.confirmDialogDeleteLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        await this.updateEmployeeListInRole({
          company_uuid,
          role_uuid: this.employeeListInRole.role_uuid,
          data: {
            employees: this.employeeListInRole.employees
              .filter(
                (employee) => employee.employee_uuid !== item.employee_uuid
              )
              .map((employee) => employee.employee_uuid),
          },
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false
      }
    },
    onClose() {
      this.$emit('onCloseEmployeeListInRoleDialog')
      this.search = ''
    },
    async onRefresh() {
      try {
        this.loading = true

        const payload = {
          company_uuid: this.$store.state.authentication.company.company_uuid,
          role_uuid: this.employeeListInRole.role_uuid,
        }

        await this.fetchEmployeeListInRole(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
